import React, { Component } from 'react'
import Page from '../../containers/page'

import { Container, Row, Col, Input, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap'

import Isvg from 'react-inlinesvg'

import Search from '../../components/search'
import { Link } from 'react-router-dom'

import ListBuilder from '../../components/listBuilder'
import DeleteModal from '../../components/deleteModal'
import {
    getSearchParams,
    generateSearchLink,
    generateSearchLinkMultiple,
} from '../../helpers/linkHelper'
import { API_ENDPOINT } from '../../constants'

import garabageIcon from '../../assets/svg/garabage.svg'
import userIcon from '../../assets/svg/user-icon.svg'
import notification from '../../assets/svg/notification.svg'
import profile from '../../assets/svg/profile-image.svg'
import moreIcon from '../../assets/svg/more.svg'
import map from '../../assets/svg/map.svg'
import copyIcon from '../../assets/svg/copy_icon.svg'
import editIcon from '../../assets/svg/edit.svg'
import viewIcon from '../../assets/svg/open.svg'

import fastEditIcon from '../../assets/svg/fast_edit.svg'



import Toggle from '../../components/forms/fields/toggle'
import FormBuilder from '../../components/forms/formBuilder'

class List extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0,
            },
            items: [],
            areas: [],
            total: 0,
            loading: true,
            newsData: [],
        }
    }

    get = () => {
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    })
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        )
                    }
                )
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    })
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        )
                    }
                )
            })
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0)
        }

        if (this.props[0].location && this.props[0].location.state && this.props[0].location.state.page) {
            this.updateParams('page', this.props[0].location.state.page)
        } else {
            this.get()

        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState(
                {
                    loading: true,
                },
                () => {
                    this.get()
                }
            )
        }
    }

    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params
            state.sortField = field
            state.sortType = type
            this.setState({
                params: state,
            })
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    [
                        { name: 'sortField', value: field },
                        { name: 'sortType', value: type },
                    ],
                    false
                )
            )
        }
    }

    updateParams = (name, value, restart = false) => {

        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                }
                obj[name] = value
                this.setState({ params: obj })
            } else {
                let obj = this.state.params
                obj[name] = value
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(
                generateSearchLink(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    name,
                    value,
                    restart
                )
            )
        }
    }

    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                }
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value
                }
                this.setState({ params: obj })
            } else {
                let obj = this.state.params
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    fields,
                    restart
                )
            )
        }
    }

    delete = (id) => {
        this.setState(
            {
                loading: true,
            },
            () => {
                fetch(API_ENDPOINT + `/data/dynamic-tables/project/${id}`, {
                    method: 'DELETE',
                    headers: {
                        'content-type': 'application/json',
                        Authorization:
                            typeof localStorage !== 'undefined'
                                ? `Bearer ${localStorage.getItem('authToken')}`
                                : null,
                    },
                })
                    .then((res) => res.json())
                    .then((result) => {
                        this.get()
                    })
            }
        )
    }

    render() {
        let params = {}
        if (this.state.useState) {
            params = this.state.params
        } else {
            params = getSearchParams(this.props[0].location.search, {
                entries: 10,
                page: 0,
            })
        }


        return (
            <div className='page'>
                <Container className='dashboard'>
                    <Row>
                        <Col lg='12'>
                            <Search updateParams={this.updateParams} />
                            <div className='panel'>
                                <div className='main-table-header'>
                                    <h5 className='component-header'>Lista</h5>
                                    <button className='add-news'>
                                        <Link to='/projects/new'>
                                            Dodaj projekat
                                        </Link>
                                    </button>
                                </div>

                                <ListBuilder
                                    loading={this.state.loading && false}
                                    total={this.state.total}
                                    showNumeration={false}
                                    fields={[
                                        {
                                            type: 'text', class: 'labelbam', name: 'name', sortLabel: 'Po imenu', allowSort: false,
                                        },
                                        {
                                            type: 'text', class: 'labelbam', name: 'label', sortLabel: 'Po nazivu', allowSort: false,
                                        },
                                    ]}
                                    rawItems={this.state.items}
                                    items={


                                        this.state.items.map((item, idx) => {
                                            return {
                                                ...item,
                                                name: item.name,

                                            }

                                        })

                                    }
                                    actions={[

                                        {
                                            type: 'functionAction',
                                            render: (item) =>
                                                <Link to={{
                                                    pathname: `/dynamic-tables/list/${item._id}`,
                                                    state: { page: params && params.page }
                                                }}
                                                >
                                                    <Isvg style={{ minWidth: 28 }} src={viewIcon} />
                                                </Link>,
                                        },
                                        {
                                            type: 'functionAction',
                                            render: (item) =>
                                                <Link to={{
                                                    pathname: `/projects/${item._id}`,
                                                    state: { page: params && params.page }
                                                }}
                                                >
                                                    <Isvg style={{ minWidth: 28 }} src={editIcon} />
                                                </Link>,
                                        },
                                        {
                                            component: <Isvg src={garabageIcon} className='edit-icon' />,
                                            onClick: (item) => this.setState({ deleteModal: item })
                                        },
                                        {
                                            type: 'functionAction',
                                            render: (item) => <div>
                                                <div className='switch-list-builder-wrap'>
                                                    <Toggle value={item && item.isActive} onChange={(e) => {
                                                        let status = e.target.checked;
                                                        let id = item._id;
                                                        if (id) {
                                                            let loadingToggle = this.state.loadingToggle ? this.state.loadingToggle : [];
                                                            loadingToggle.push(id)
                                                            this.setState({ loadingToggle }, () => {
                                                                fetch(API_ENDPOINT + `/data/dynamic-tables/project/${id}`, {
                                                                    method: 'PATCH',
                                                                    headers: {
                                                                        'content-type': 'application/json',
                                                                        Authorization:
                                                                            typeof localStorage !== 'undefined'
                                                                                ? `Bearer ${localStorage.getItem('authToken')}`
                                                                                : null,
                                                                    },
                                                                    body: JSON.stringify({
                                                                        isActive: status,
                                                                    })
                                                                })
                                                                    .then((res) => res.json())
                                                                    .then((result) => {
                                                                        if (result && result.id) {
                                                                            let loadingToggle = this.state.loadingToggle && this.state.loadingToggle.length ? this.state.loadingToggle.filter(el => el !== result.id) : [];
                                                                            this.setState({ loadingToggle })
                                                                        }
                                                                        this.get()
                                                                    })
                                                            })


                                                        }

                                                    }} />
                                                </div>
                                            </div>,
                                        },
                                    ]}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                                <DeleteModal
                                    isOpen={this.state.deleteModal}
                                    toggle={() => this.setState({ deleteModal: null })}
                                    handler={() => { this.delete(this.state.deleteModal._id); this.setState({ deleteModal: null }) }}
                                >
                                    Obrisi <strong>{this.state.deleteModal && this.state.deleteModal.name}</strong>?
                                </DeleteModal>

                            </div>
                        </Col>
                    </Row>
                </Container>

            </div>
        )
    }
}

export default Page(List)
